
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "Phyllodes_tumor_of_breast",
components: {
XTable
}
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Phyllodes_tumor_of_breast.vue